import configSingletonInstance from 'src/ConfigSingleton';

export default function getProductType() {
  const productsArray = [
    { product: 'saas', value: 'Precisa' },
    { product: 'whitelabel-signzy', value: 'Signzy' }
  ];
  const envConfig = configSingletonInstance.getConfig();
  const productType = productsArray.find(
    e => e.product === envConfig.REACT_APP_PRODUCT_TYPE
  )
    ? productsArray.find(e => e.product === envConfig.REACT_APP_PRODUCT_TYPE)
        .value
    : 'Precisa';

  return productType;
}
